/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="81.47"
        height="81.52"
        viewBox="0 0 81.47 81.52"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M32.93 12.07v4.18l-.65.12-.66.14a10 10 0 0 0-7.55 6.12 12.42 12.42 0 0 0-.87 5.72 9.78 9.78 0 0 0 5.3 8.34 40.24 40.24 0 0 0 4.39 2c1.84.78 3.7 1.48 5.54 2.26a3.36 3.36 0 0 1 2.07 3.63 3.66 3.66 0 0 1-3 3.66 10.73 10.73 0 0 1-2.33.25 5.75 5.75 0 0 1-5.89-4.31c-.17-.51-.3-1-.46-1.6l-7 1.8a14.47 14.47 0 0 0 3.39 6.94 11.78 11.78 0 0 0 7.68 3.54v5.42h4.61v-5.37c.91-.18 1.8-.32 2.66-.54a10.47 10.47 0 0 0 7.38-6 12.25 12.25 0 0 0 .85-7.31 9.63 9.63 0 0 0-4.91-6.95 54.78 54.78 0 0 0-6.71-2.94c-1.37-.54-2.71-1.18-4-1.82a2.91 2.91 0 0 1-1.58-1.85 4.07 4.07 0 0 1 2.86-5.14 4.74 4.74 0 0 1 4.69 1.22 9 9 0 0 1 1.91 2.92c.15.34.29.69.45 1.06l6.28-2.59a12.64 12.64 0 0 0-2.31-4.73 11 11 0 0 0-7.62-4v-4.17Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M.1 32.78a35.39 35.39 0 1 1 67.4 17.61 1.253 1.253 0 0 1-2.27-1.06 32.88 32.88 0 1 0-17.78 16.68 1.253 1.253 0 0 1 .92 2.33A35.41 35.41 0 0 1 .1 32.78Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M50.28 49.24h.43L80.6 59.87a1.25 1.25 0 0 1 .2 2.27l-.13.06-9.08 3.85 7.69 8.75a1.27 1.27 0 0 1 0 1.61l-.1.1-4.57 4.58a1.26 1.26 0 0 1-1.74 0l-.1-.1-8-9.3-4.73 8.84a1.25 1.25 0 0 1-2.26-.12v-.12L49.15 50.8V50l.05-.11.07-.1.07-.09.09-.09.09-.07.11-.06H49.97Zm2 3.25 7.12 24.25 4.15-7.75a1.25 1.25 0 0 1 2-.33l.09.1 8.29 9.67 2.8-2.8-8.13-9.13a1.25 1.25 0 0 1 .34-1.92l.11-.06 7.72-3.28Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DollarSignWithCircleAndMouseArrowIcon';

export default Icon;
